import { io, type Socket } from "socket.io-client";
import { getAccessToken } from "./api";

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io("/", {
      transports: ["websocket", "polling"],
      auth: (cb) => cb({ token: getAccessToken() }),
    });
  }
  return socket;
}

export function reconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket.connect();
  }
}
